import { mergeRight } from 'ramda'

const defaultState = {
  contact: {}
}

const contactDetails = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_CONTACT':
      return mergeRight(state, {
        contact: action.contact
      })
    
    default:
      return state
  }
}

export default contactDetails